export default __webpack_public_path__ + "static/media/icon-back.eed82c49.svg";